import { useMemo } from 'react'
import dayjs from 'dayjs'
import durationPlugin from 'dayjs/plugin/duration'
import cx from 'classnames'
import styles from './countdown.module.scss'
import { useCountDown } from 'hooks'

dayjs.extend(durationPlugin)

interface CountDownProps {
  targetDateTime: string
  size: string
  headerText?: string
  callBack?: () => void
}
export const CountDown: React.FC<CountDownProps> = ({
  targetDateTime,
  size = 'large',
  headerText = 'Time Left',
  callBack,
}) => {
  const timeUntilTimestamp = useMemo(() => new Date(targetDateTime).getTime(), [targetDateTime])
  const timeLeft = useCountDown(timeUntilTimestamp, callBack)

  if (timeUntilTimestamp < 0) return null

  return (
    <div className={styles[`size_${size}`]}>
      <div className={styles.header_text}>{headerText}</div>
      <div className={cx(styles.container, 'flex justify-between sm:justify-start')}>
        <div className={styles.time_frame}>
          <div className={styles.number}>{timeLeft.days}</div>
          <div className={styles.unit}>{parseInt(timeLeft.days) > 1 ? 'days' : 'day'}</div>
        </div>
        <div className={styles.colon}>:</div>
        <div className={styles.time_frame}>
          <div className={styles.number}>{timeLeft.hours}</div>
          <div className={styles.unit}>{parseInt(timeLeft.hours) > 1 ? 'hours' : 'hour'}</div>
        </div>
        <div className={styles.colon}>:</div>
        <div className={styles.time_frame}>
          <div className={styles.number}>{timeLeft.minutes}</div>
          <div className={styles.unit}>{parseInt(timeLeft.minutes) > 1 ? 'minutes' : 'minute'}</div>
        </div>
        <div className={styles.colon}>:</div>
        <div className={styles.time_frame}>
          <div className={styles.number}>{timeLeft.seconds}</div>
          <div className={styles.unit}>{parseInt(timeLeft.seconds) > 1 ? 'seconds' : 'second'}</div>
        </div>
      </div>
    </div>
  )
}

export default CountDown
